import { render } from "./ProductsView.vue?vue&type=template&id=5a932f18&scoped=true"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"

import "./ProductsView.vue?vue&type=style&index=0&id=5a932f18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a932f18"

export default script